export default {
  BLIP_1: {
    title: 'Received Messages',
    description: 'Total messages received in the period (from contacts to the bot).',
  },
  BLIP_2: {
    title: 'Sent Messages',
    description: 'Total messages sent in the period (from the bot to contacts).',
  },
  BLIP_3: {
    title: 'Active Messages',
    description: 'Total active messages sent in the period (24 hours after the last contact interaction).',
  },
  BLIP_4: {
    title: 'Total Unique Contacts in Period',
    description: 'Total unique contacts in the period who received or sent a message to the bot.',
  },
  BLIP_5: {
    title: 'Contacts with Interaction in Period',
    description: 'Total unique contacts in the period who sent a message to the bot.',
  },
  BLIP_6: {
    title: 'Unique Contacts by Interval',
    description: 'Unique contacts per interval (day or month) who received or sent a message to the bot.',
  },
  BLIP_7: {
    title: 'Contacts with Interaction by Interval',
    description: 'Unique contacts per interval (day or month) who sent a message to the bot.',
  },
  BLIP_8: {
    title: 'Sent Messages by Interval',
    description: 'Messages sent per interval (day or month) from the bot to contacts.',
  },
  BLIP_9: {
    title: 'Received Messages by Interval',
    description: 'Messages received per interval (day or month) from the bot to contacts.',
  },
  BLIP_10: {
    title: 'Active Messages by Interval',
    description: 'Active messages sent per interval (day or month), 24 hours after the last contact interaction.',
  },
  BLIP_11: {
    title: 'Message Volume in Period',
    description: 'Line chart with total sent and received messages within the selected period.',
  },
  BLIP_12: {
    title: 'Contacts Who Did Not Respond',
    description: 'Total unique contacts who did not respond to any message sent by the chatbot and did not initiate any conversation in the selected period.',
  },
  BLIP_13: {
    title: 'Contacts with Interaction vs. Contacts Who Did Not Respond',
    description: 'Line chart with total unique contacts who did not respond and unique contacts who interacted with the chatbot within the selected period.',
  },
  BLIP_14: {
    title: 'Rejection Rate',
    description: 'Percentage of unique contacts who did not respond to the chatbot divided by the total number of unique contacts in the selected period. Calculated using the formula: Non-Responding Contacts / Total Unique Contacts * 100%.',
  },
  BLIP_15: {
    title: 'Active Messages by Channel',
    description: 'Table with the total active messages sent per channel in the selected time period. Active messages are those sent by the chatbot more than 24 hours after the last message received from the contact.',
  },
  BLIP_16: {
    title: 'Interaction Rate',
    description: 'Percentage of unique contacts who responded and interacted with the chatbot out of the total unique contacts in the selected period. Calculated using the formula: Contacts with Interaction / Total Unique Contacts * 100%.',
  },
  BLIP_17: {
    title: 'Total Message Volume',
    description: 'Total messages sent and received by the chatbot in the conversational flow. Also includes messages exchanged in Blip Desk between contacts and agents.',
  },
  BLIP_18: {
    title: 'Total Custom Events',
    description: 'Total number of Custom Events according to the options applied in the filter within the selected period.',
  },
  BLIP_19: {
    title: 'Custom Events Distribution',
    description: 'Distribution of Custom Events according to the options applied in the filter within the selected period.',
  },
  BLIP_20: {
    title: 'Custom Events Distribution (Percentage)',
    description: 'Distribution of Custom Events according to the options applied in the filter within the selected period.',
  },
  BLIP_21: {
    title: 'Custom Events Over Time',
    description: 'Distribution of Custom Events according to the options applied in the filter over a time period. Note: Only the top 50 most frequent actions are shown.',
  },
  BLIP_22: {
    title: 'My Campaigns',
    description: 'Total active campaigns sent and scheduled through smart contacts in the selected period.',
  },
  BLIP_23: {
    title: 'Open Tickets',
    description: 'Total tickets that were opened in the selected period.',
  },
  BLIP_24: {
    title: 'Missed Tickets',
    description: 'Total service sessions closed by the customer while still in the service queue and not yet assigned to an agent.',
  },
  BLIP_25: {
    title: 'Abandoned Tickets',
    description: 'Total service sessions closed by the customer that were later distributed to or picked up by an agent.',
  },
  BLIP_26: {
    title: 'Attended Tickets',
    description: 'Total service sessions that were finalized or transferred to another queue or agent.',
  },
  BLIP_27: {
    title: 'Closed Tickets',
    description: 'Total sum of missed, abandoned, and attended service sessions.',
  },
  BLIP_28: {
    title: 'Conversion Funnel',
    description: 'Shows performance metrics per stage for active message sends by the selected smart contacts.',
  },
  BLIP_29: {
    title: 'Maximum Queue Time',
    description: 'Shows the longest time a customer waited in the queue until being assigned to or picked up by an agent. Only closed tickets in the selected period that have already been removed from the agent\'s screen are considered.',
  },
  BLIP_30: {
    title: 'Maximum Time to First Response',
    description: 'Shows the maximum time a customer waited to receive the first contact from the agent after being assigned. Only closed tickets in the selected period that have already been removed from the agent\'s screen are considered.',
  },
  BLIP_31: {
    title: 'Average Queue Time',
    description: 'Average time customers wait in the queue until being assigned to an agent. Calculated using only closed tickets in the selected period that have already been removed from the agent\'s screen.',
  },
  BLIP_32: {
    title: 'Average Time to First Response',
    description: 'Average time agents take to send the first message to the customer after assignment. Calculated using only closed tickets in the selected period that received a first response and have been removed from the agent\'s screen.',
  },
  BLIP_33: {
    title: 'Average Wait Time',
    description: 'Average time a customer waits to receive the first service response, measured from when the ticket is assigned to a queue until the agent sends the first reply.',
  },
  BLIP_34: {
    title: 'Average Response Time',
    description: 'Average time agents take to reply to customer messages. Calculated using only tickets with at least one complete exchange between customer and agent, closed in the selected period, and already removed from the agent\'s screen.',
  },
  BLIP_35: {
    title: 'Average Service Time',
    description: 'Calculated using only closed tickets in the period that have already been removed from the agent\'s screen.',
  },
  BLIP_36: {
    title: 'Ticket Volume by Day',
    description: 'Number of tickets opened and closed per day within the selected time period.',
  },
  BLIP_37: {
    title: 'Agent Availability',
    description: 'Report showing the time each agent spent in each status, providing a view of their availability in the selected time period.',
  },
  BLIP_38: {
    title: 'Service Reports - Agents',
    description: 'Report of finalized tickets and their respective metrics by Agent within the selected time period.',
  },
  BLIP_39: {
    title: 'Service Reports - Queues',
    description: 'Report of finalized tickets and their respective metrics by Queue within the selected time period.',
  },
  BLIP_40: {
    title: 'Service Reports - Tags',
    description: 'Report of finalized tickets and their respective metrics by Tag within the selected time period.',
  },
  BLIP_41: {
    title: 'Tickets per Agent',
    description: 'Average tickets currently assigned to agents.',
  },
  BLIP_42: {
    title: 'Ticket Volume in Queue',
    description: 'Number of tickets in service queues. Considers all unassigned tickets across all queues of this bot, or filtered queues.',
  },
  BLIP_43: {
    title: 'Tickets in Service',
    description: 'Total tickets currently in service — already assigned to or picked up by an agent and having received the first response, but not yet closed.',
  },
  BLIP_44: {
    title: 'Online Agents',
    description: 'Number of agents who are active and ready to receive new service sessions.',
  },
  BLIP_45: {
    title: 'Agents on Break',
    description: 'Number of agents currently on a break (standard or custom, such as lunch or bathroom break) and therefore not receiving new service sessions.',
  },
  BLIP_46: {
    title: 'Offline Agents',
    description: 'Number of agents who are inactive and cannot receive new service sessions.',
  },
  BLIP_47: {
    title: 'Service Management - Assigned/In Service',
    description: 'List of service sessions already assigned to an agent and sessions currently in progress.',
  },
  BLIP_48: {
    title: 'Service Management - Waiting for Service',
    description: 'List of service sessions currently in the queue and not yet assigned to an agent.',
  },
  BLIP_49: {
    title: 'Service Management - Agents',
    description: 'List of assigned service sessions grouped by agent.',
  },
  BLIP_50: {
    title: 'Service Management - Queues',
    description: 'List of service sessions grouped by queue.',
  },
  BLIP_51: {
    title: 'Service Management - Tags',
    description: 'List of finalized service sessions grouped by tags.',
  },
};
